import { useEffect, useState } from 'react';

import RouterPromptModal from 'components/RouterPromptModal/RouterPromptModal';
import { TwoPaneLayout } from 'components/two-pane-layout/two-pane-layout';
import { unsavedDataChanged } from 'features/rules/redux/rules-slice';
import { useHistory } from 'react-router-dom';
import { useAppDispatch } from 'redux/hooks';
import { FormButtons } from '../form-buttons/form-buttons';
import { RuleTabs } from '../rule-tabs/rule-tabs';
import { CompetitorInfo } from './competitor-info';
import { CompetitorTable } from './competitor-table';
import { useCompetitorsController } from './use-competitors-controller';

export const Competitors = () => {
	const dispatch = useAppDispatch();
	const history = useHistory();
	const { isDataModified, loading, saveCompetitorSet, ...tableProps } =
		useCompetitorsController();
	const [continueClicked, setContinueClicked] = useState(false);

	useEffect(() => {
		dispatch(unsavedDataChanged(isDataModified));
	}, [dispatch, isDataModified]);

	return (
		<div>
			<RouterPromptModal isBlocked={isDataModified && !continueClicked} />
			<RuleTabs loading={loading} />
			<TwoPaneLayout
				loading={loading}
				LeftSideComponent={<CompetitorTable {...tableProps} />}
				RightSideComponent={<CompetitorInfo />}
			/>
			<FormButtons
				loading={loading}
				dirty={isDataModified}
				onSaveClick={saveCompetitorSet}
				onContinueClick={async () => {
					setContinueClicked(true);
					const success = await saveCompetitorSet();
					if (success) {
						history.push('/rules/rates');
					} else {
						setContinueClicked(false);
					}
				}}
			/>
		</div>
	);
};
